import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Stack, Button, Typography, Grid2 as Grid } from '@mui/material';
import { Menu } from '@/types/menus';
import { useAccessControl, withAccessControl } from '@/features/access-control';
import UpdateMenuDrawer from './components/UpdateMenuDrawer';
import PageHeader from '@/components/PageHeader';
import { useFetchMenusQuery } from '@/features/organizations/api/menusApi';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import MenuCard from './components/MenuCard';
import CreateMenuDrawer from './components/CreateMenuDrawer';
import OrganizationMenuSkeleton from './components/OrganizationMenuSkeleton';

const OrganizationMenus = () => {
  const { hasAccess } = useAccessControl();
  const { organizationId } = useParams<{ organizationId: string }>();
  const [selectedMenu, setSelectedMenu] = useState<Menu>();
  const [isNewMenuDrawerOpen, setIsNewMenuDrawerOpen] = useState(false);
  const { isFetching, data } = useFetchMenusQuery(organizationId ?? skipToken);

  const onCloseMenuSettings = () => {
    setSelectedMenu(undefined);
  };

  return (
    <Stack spacing={3}>
      <PageHeader
        title="Menús"
        action={
          hasAccess('create.menu') ? (
            <Button
              size="large"
              color="success"
              onClick={() => setIsNewMenuDrawerOpen(true)}
            >
              Crear Menú
            </Button>
          ) : undefined
        }
      />
      {isFetching && !data ? (
        <Grid container spacing={3}>
          {['', ''].map((s, i) => (
            <Grid key={`skelrton-${i}`} size={{ xs: 12, lg: 6, xl: 4 }}>
              <OrganizationMenuSkeleton/>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={3}>
          {data?.map((menu) => (
            <Grid key={menu.id} size={{ xs: 12, lg: 6, xl: 4 }}>
              <MenuCard
                title={menu.title}
                createdBy={menu.createdBy}
                lastUpdatedAt={menu.lastUpdatedAt}
                onClick={() => setSelectedMenu(menu)}
              />
            </Grid>
          ))}
        </Grid>
      )}
      <UpdateMenuDrawer
        selectedMenu={selectedMenu}
        onClose={onCloseMenuSettings}
      />
      <CreateMenuDrawer
        isOpen={isNewMenuDrawerOpen}
        onClose={() => setIsNewMenuDrawerOpen(false)}
      />
    </Stack>
  );
};

export default withAccessControl(OrganizationMenus, 'view.menu');
